<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="uIWTfSpJpovKqdQJFO3lBtD">
<p class="Perfect-Center" lang="en-US"><span class="Basic_italics"><br/></span></p>
<p class="Perfect-Center" lang="en-US"><span class="Basic_italics"><br/></span></p>
<p class="Perfect-Center" lang="en-US"><span class="Basic_italics"><a id="uUbEndsekDQD9giwdBCT3I4"></a>For Howard Lapides</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?a9b89d40